import { booking_information_token } from "./Booking_Information_Token";

export class booking_information {
    public affiliate_app_id: string | null = null;
    public affiliate_contact: string | null = null;
    public iso_currency_code: string = "";
    public booking_reference: string | null = null;
    public token: booking_information_token = new booking_information_token();
}
